import Core from './Core'
import Sub from './Sub'

export default { Core, Sub }
